"use client";
import { Sport } from "common";
import ReactTimeAgo from "react-time-ago";
import Button from "../primitives/button";
import Icon from "../primitives/icon";
import RelativeTime from "../relative-time";

interface NewsHeaderProps {
  headline: string;
  sport: Sport;
  date: string;
}
export default function NewsHeader(props: NewsHeaderProps) {
  return (
    <div className="flex flex-col gap-4">
      <div className="mt-6 max-w-[668px] text-display-xl uppercase">
        <h1>{props.headline}</h1>
      </div>
      <div className="flex flex-row justify-between items-center">
        <NewsTimestamp sport={props.sport} date={props.date} />
        {/* <NewsShare /> */}
      </div>
    </div>
  );
}

interface NewsTimestampProps {
  sport: Sport;
  date: string;
}

function NewsTimestamp(props: NewsTimestampProps) {
  return (
    <div className="flex gap-2 text-dark text-title-sm-medium">
      <span className="uppercase">{props.sport}</span>
      <span>•</span>
      <span>
        <RelativeTime date={props.date} />
      </span>
    </div>
  );
}

export function NewsShare() {
  return (
    <div className="flex items-center gap-2">
      <div className="text-dark text-label-lg-bold uppercase">
        Share Article
      </div>
      <Button size="xs" color="secondary" className="px-2 py-1.5">
        <Icon name="share" size="md"></Icon>
      </Button>
    </div>
  );
}
